export default ({ app, store }) => {
  app.router.beforeEach((_to, _from, next) => {
    app.store.commit('modal/UNSET_MODAL')
    app.store.commit('navigation/SET_IS_SUBPAGE_OPEN', null)
    store.commit('router/SET_PREV_ROUTE', _from.name ? _from : null)
    next()
  })
}
